export function areObjectsEqual<T extends Object>(objectA: T, objectB: T) {
    return (Object.keys(objectA) as Array<keyof T>).every(key => objectA[key] === objectB[key]);
}

export function areObjectsDifferent<T extends Object>(objectA: T, objectB: T) {
    return !areObjectsEqual(objectA, objectB);
}